import { createFileRoute } from '@tanstack/react-router';

import { DictionaryValuesPage } from '@/features/catalog/DictionaryValuesPage';

/**
 * Карточка справочника со значениями. Идентификатор в адресе, а не в состоянии списка:
 * ссылку на конкретный справочник нужно уметь переслать коллеге — из формы атрибута,
 * из отказа удаления, из переписки.
 */
export const Route = createFileRoute('/_app/catalog_/dictionaries_/$dictionaryId')({
  component: DictionaryValuesRoute,
});

function DictionaryValuesRoute() {
  const { dictionaryId } = Route.useParams();
  return <DictionaryValuesPage dictionaryId={dictionaryId} />;
}
